module.exports = __webpack_public_path__ + "img/ic_dashboard_battle_win.368bf20a.svg";